import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import { useCallback, useRef } from 'react';
import { EQLFunction, EQLFunctionName } from 'v2/core/repository/eql/types';
import { shallow } from 'zustand/shallow';

export function useAddSearchBucketsFunctionIfRequired() {
  const dependencies = useQuantifyStore(({ visual }) => {
    return {
      searchTerm: visual.searchTerm,
    };
  }, shallow);

  const dependenciesRef = useRef(dependencies);
  dependenciesRef.current = dependencies;

  return useCallback((functions: EQLFunction[]) => {
    if (!!dependenciesRef.current.searchTerm) {
      functions.push({
        name: EQLFunctionName.SearchBucketKeys,
        params: [dependenciesRef.current.searchTerm],
      });
    }
  }, []);
}
